import { TableCell } from "@/components/ui/table"
import { CalendarPlus, CalendarClock } from "lucide-react"
import type { Project } from "@/types"

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
}

export function DatesCell({ project }: { project: Project }) {
  return (
    <TableCell>
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground" title="Date de création">
          <CalendarPlus className="size-3.5" />
          {formatDate(project.created_at)}
        </span>
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground" title="Dernière modification">
          <CalendarClock className="size-3.5" />
          {formatDate(project.updated_at)}
        </span>
      </div>
    </TableCell>
  )
}
